import React, { useState, useEffect } from "react";
import Layout from "../../components/Layout/Layout";
import BeatLoader from "react-spinners/BeatLoader";
import { collection, getDocs, getDoc, doc } from "@firebase/firestore";
import { auth, db } from "../../firebase/firebase-config";

import { BsPersonFillAdd } from "react-icons/bs";
import { FiFolderPlus } from "react-icons/fi";
import SelectUserModal from "../../components/ui/SelectUserModal/SelectUserModal";
import AssignSlideModal from "../../components/ui/AssignSlideModal/AssignSlideModal";

import { Table, Input, Select } from 'antd';
import type { SelectProps } from 'antd';

const { Search } = Input;


const override = {
  marginTop: "20px",
};

function Index() {
  const [loading, setLoading] = useState(false);
  const [slideData, setSlideData] = useState<any>([]);
  const [pathos, setPathos] = useState([]);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showCaseModal, setShowCaseModal] = useState(false);
  const [selectedSlide, setSelectedSlide] = useState("");
  const [selectedCaseSlide, setSelectedCaseSlide] = useState("");
  const [selectedModal, setSelectedModal] = useState("");
  const [caseData, setCaseData] = useState([]);
  const [searchText, setSearchText] = useState<string>('');
  const [filteredData, setFilteredData] = useState<any[]>(slideData);
  let [tableKey, setTableKey] = useState(1);
      

  const toggleAddModal = async () => {
    setShowCaseModal(!showCaseModal);
  };

  const toggleShowCreate = async () => {
    // fetchUsers().then(doc => console.log(doc.data()))
    setShowCreateModal(!showCreateModal);
  };



  const handleContentAdded = () => {
    toggleAddModal();
  };

  const handleSlideAdded = () => {
    toggleShowCreate();
  }

  const fetchData = async () => {
    setLoading(true);

    const slides = await getDocs(collection(db, "Slides"));
    const users = await getDocs(collection(db, "users"));
    const cases = await getDocs(collection(db, "Cases"));

    const res: any = [];
    const tempPathos: any = [];
    const tempCase: any = [];
    
    slides.forEach((slide) => {
      res.push({
        name: slide.id,
        ...slide.data(),
      });

      // setLoading(false);
    });

    // setSlideData(res);
    // const promises = res.map(async (data: any) => {
    //   console.log('DATA#####!!!!: ', res);
    //   if(data?.assigned_case) {
    //     const _cData = await getDoc(doc(db, 'Cases', data?.assigned_case));
    //     if(_cData.data()) {
    //       // console.log('CASE DATA: ', _cData.data())
    //       return {
    //         case_code: _cData.data()?.CID,
    //         ...data
    //       }
    //     }else {
    //       return {
    //         case_code: '------',
    //         ...data
    //       }
    //     }
    //   }else {
    //     return {
    //       case_code: '------',
    //       ...data
    //     }
    //   }
    // })

    // console.log('GOT HERE COOL');
    // Promise.all(promises).then((newRes: any) => {
    //   console.log('NEW CASES OBJ');
    //   setSlideData(newRes)
    //   setLoading(false);
    // });

    async function processArray() {
      const newRes = [];
      for (const data of res) {
        // console.log('DATA#####!!!!: ', res);
        let caseCode = '------';
        if (data?.assigned_case) {
          const _cData = await getDoc(doc(db, 'Cases', data?.assigned_case));
          if (_cData.data()) {
            caseCode = _cData.data()?.CID;
          }
        }
        newRes.push({
          case_code: caseCode,
          ...data
        });
      }
    
      // console.log('NEW CASES OBJ', newRes);
      setSlideData(newRes);
      setLoading(false);
    }
    
    // console.log('GOT HERE COOL');
    processArray().catch((error) => {
      console.log('Error occurred during processing', error);
    });

    users.forEach((user) => {
      const data = user.data();

      if (data?.status && data?.speciality === "pt") {
        tempPathos.push({
          id: user.id,
          ...user.data(),
        });
      }
    });
    setPathos(tempPathos);

    

    cases.forEach((case_) => {
      const temp = case_.data();
      // console.log('CASE #: ', case_.data());
      if (temp.label === "PATHO") {
        tempCase.push({
          name: case_.id,
          ...case_.data(),
        });
      }
      setCaseData(tempCase);
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const rows: any = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      render: (text: any, record: any, index: number) => index + 1,
    },
    {
      title: 'Slide Name',
      dataIndex: 'name',
      key: 'name',
      sorter: (a: any, b: any) => a.name.localeCompare(b.name),
    },
    {
      title: 'Review Status',
      dataIndex: 'report',
      key: 'report',
      sorter: (a: any, b: any) => (a.report ? 1 : -1) - (b.report ? 1 : -1),
      render: (report: boolean) => (report ? "Reviewed" : "Not Reviewed"),
    },
    {
      title: 'Author',
      dataIndex: 'author',
      key: 'author',
      // sorter: (a: any, b: any) => (a.owner ? 1 : -1) - (b.owner ? 1 : -1),
    },
    {
      title: 'Reviewers',
      dataIndex: 'access',
      key: 'access',
      sorter: (a: any, b: any) => {
        if (a && a.access && a.access.length && b && b.access && b.access.length) {
          return a.access.length - b.access.length;
        } else if (a && a.access && a.access.length) {
          return -1;
        } else if (b && b.access && b.access.length) {
          return 1;
        }
        return 0;
      },
      render: (access: any) => access.length,

    },
    {
      title: 'Reports',
      dataIndex: 'reports',
      key: 'reports',
      sorter: (a: any, b: any) => (a.report ? 1 : -1) - (b.report ? 1 : -1),
      render: (reports: boolean) => (reports ? "Available" : "-"),
    },
    {
      title: 'Case Code',
      dataIndex: 'case_code',
      key: 'case_code',
      sorter: (a: any, b: any) => a.case_code.localeCompare(b.case_code),
      render: (assignedCase: any) => (assignedCase ? assignedCase : "-"),
    },

    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (_: any, record: any) => (
        <td className="flex-start">
          {/* <i
            style={{ position: "relative", top: 3, cursor: "pointer" }}
            onClick={() => {
              // setSelectedModal("Slide")
              setSelectedSlide(record.name);
              toggleShowCreate();

            }}
          >
            <BsPersonFillAdd
              style={{
                backgroundColor: "#07575b",
                padding: 5,
                borderRadius: 5,
                color: "white",
                marginRight: 15,
              }}
              size={30}
            />
          </i> */}

          <i
            style={{ position: "relative", top: 3, cursor: "pointer" }}
            onClick={() => {
              // setSelectedModal("Case")
              setSelectedSlide(record.name);
              toggleAddModal();

            }}
          >
            <FiFolderPlus
              style={{
                backgroundColor: "#07575b",
                padding: 5,
                borderRadius: 5,
                color: "white",
              }}
              size={30}
            />
          </i>
        </td>
      ),
    },
 
  ];

  // console.log(slideData)

  const [sortedInfo, setSortedInfo] = useState<any>({});

  const handleChange = (pagination: any, filters: any, sorter: any) => {
    setSortedInfo(sorter);
  };

  slideData.forEach((item: any, index: any) => {
    item.index = index + 1;
  });

  useEffect(() => {
    setFilteredData(filterData(slideData, searchText));
  }, [slideData, searchText]);

  useEffect(() => {

  }, [])
  
  const filterData = (data: any[], query: string) => {
    if (!query) return data;

    return data.filter((item) =>
      Object.values(item).some((value: any) =>
        value == null ? "" : value.toString().toLowerCase().includes(query.toLowerCase())
      )
    );
  };


  const handleSearch = (value: string) => {
    setSearchText(value);
  };


 

  

  return (
    <>
      <Layout title="Slides" pageTitle="images">
        <div className="section">
          <div className="parent-con">
            <div className="data-table">
              <div className="top">
                <div className="span">
                  <h3>All Slides</h3>
                </div>

                {/* <button className="btn btn-primary btn-add student-button">
                New Slide
              </button> */}
              </div>

              <div className="table-con">
                <div style={{ textAlign: "center" }}>
                  <BeatLoader
                    color="#3080ED"
                    loading={loading}
                    cssOverride={override}
                  />
                </div>
                <Search
                  placeholder="Search for data..."
                  onSearch={handleSearch}
                  onChange={(e) => handleSearch(e.target.value)}
                  value={searchText}
                  style={{ width: 200, marginBottom: 16 }}
                />
  
                <Table

                  dataSource={filteredData.map((item, index) => ({ ...item, index: index + 1 }))}

                  columns={rows}
                  onChange={handleChange}
                  rowKey="name"
                  showSorterTooltip={false}
                  key={filteredData.length}
                  pagination={{ pageSize: 10 }}
                />
                {/* <table>
                  <thead>
                    <tr>
                      {rows.map((row: any, index: any) => (
                        <th key={index} className={row.name}>
                          {row.label}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {slideData?.map((data: any, index: any) => (
                      <tr key={data.name}>
                        <td className="flex-center">{index + 1}</td>
                        <td className="flex-start" style={{ fontSize: 14 }}>
                          {data.name}
                        </td>
                        <td className="flex-start">
                          <p
                            style={{ fontSize: 14, textTransform: "capitalize" }}
                          >
                            {data?.reports ? "Reviewed" : "Not Reviewed"}{" "}
                          </p>
                        </td>
                        <td style={{ textTransform: "uppercase", fontSize: 12 }}>
                          Admin
                        </td>
                        <td className="flex-start">{data.access.length}</td>
                        <td className="flex-start">
                          <p
                            style={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "10ch",
                            }}
                          >
                            {" "}
                            {data?.reports ? "Available" : "-"}{" "}
                          </p>
                        </td>
                        <td className="flex-center">
                          <p
                            style={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "10ch",
                            }}
                          >
                            {data?.assigned_case ? data?.assigned_case : "-"}
                          </p>
                        </td>
                        <td className="flex-start">
                          <i
                            style={{ position: "relative", top: 3 }}
                            onClick={() => {
                              // setSelectedModal("Slide");
                              setSelectedSlide(data.name);
                              toggleShowCreate();
                            }}
                          >
                            <BsPersonFillAdd
                              style={{
                                backgroundColor: "#07575b",
                                padding: 5,
                                borderRadius: 5,
                                color: "white",
                                marginRight: 15,
                              }}
                              size={30}
                            />
                          </i>

                          <i
                            style={{ position: "relative", top: 3 }}
                            onClick={() => {
                              // setSelectedModal("Case");
                              setSelectedSlide(data.name);
                              toggleAddModal();
                            }}
                          >
                            <FiFolderPlus
                              style={{
                                backgroundColor: "#07575b",
                                padding: 5,
                                borderRadius: 5,
                                color: "white",
                              }}
                              size={30}
                            />
                          </i>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table> */}
              </div>
            </div>
          </div>
        </div>


      </Layout>
      {showCreateModal && selectedSlide && (
        <SelectUserModal
          onContentAdded={handleContentAdded}
          onClose={toggleShowCreate}
          selectedSlide={selectedSlide}
          speciaList={pathos}
        />
      )}

      {showCaseModal && selectedSlide && (
        <AssignSlideModal
          onContentAdded={handleSlideAdded}
          onClose={toggleAddModal}
          selectedSlide={selectedSlide}
          caseList={caseData}
        />
      )}
    </>
  );
}

export default Index;
